module.exports = __webpack_public_path__ + "static/driver-experience-6b3606a3c437d03fc4011ef2accd97c4.png";